import { useContext } from "react";
import type { AuthContextData } from "../@types/contexts/Auth/AuthContext";
import { AuthContext } from "../contexts/Auth/AuthContext";

export const useAuth = (): AuthContextData => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
};
